export default __webpack_public_path__ + "static/trustwallet-65baf2a1a5c5e864d0a88bba82e8a874.svg";